import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';

import axios from "axios";
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';

const ViewLedger = () => {

    const [clients, setClients] = useState([]);
    const [balanceData, setBalanceData] = useState([]);

    // Fetch all clients
    useEffect(() => {
        axios.get("https://react-apis.dotlocalhost.com/showClients.php").then((response) => {
            setClients(response.data);
        });


        // sidebar background color set
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("accnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("vwldgr");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }
        };

    }, []);

    // Fetch and calculate balances for all clients
    // Fetch and calculate balances for all clients
    useEffect(() => {
        if (clients.length > 0) {
            const tempBalanceData = []; // Temporary array to store balance data

            // Fetch balance for each client and calculate balance
            clients.forEach((client, index) => {
                axios
                    .get(`https://react-apis.dotlocalhost.com/showClientData.php?clid=${client.clid}`)
                    .then((response) => {
                        const data = response.data;
                        if (Array.isArray(data)) {
                            // Initialize totals for debit and credit
                            let totalDebit = 0;
                            let totalCredit = 0;
                            let balance = parseFloat(data[0].balance) || 0;

                            data.forEach((row, index) => {
                                if (index > 0) {
                                    const debit = parseFloat(row.debit) || 0;
                                    const credit = parseFloat(row.credit) || 0;

                                    totalDebit += debit;  // Add to total debit
                                    totalCredit += credit; // Add to total credit

                                    balance = balance + debit - credit;
                                }
                            });

                            // Push the calculated balance and totals into the temp array
                            tempBalanceData.push({
                                clientName: client.clientName,
                                totalDebit: totalDebit.toFixed(2),
                                totalCredit: totalCredit.toFixed(2),
                                balance: balance.toFixed(2),
                            });

                            // Only set balance data once all clients are processed
                            if (index === clients.length - 1) {
                                setBalanceData(tempBalanceData); // Update state once
                            }
                        } else {
                            console.error("Data is not an array:", data);
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching client data:", error);
                    });
            });
        }
    }, [clients]);


    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5' style={{marginLeft:'5%'}}>
                            <h3>Trial Balance Sheet</h3>
                        </div>
                    </div>

                    <div style={{width:'70%', marginLeft:'5%'}}>
                        {/* Check if balanceData is populated */}
                        {balanceData.length > 0 ? (
                            <Table striped bordered hover style={{ fontSize: '12px' }}>
                            <thead>
                                <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                    <th>Client Name</th>
                                    <th>Total Debit</th>
                                    <th>Total Credit</th>
                                    <th>Balance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {balanceData.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.clientName}</td>
                                        <td>{row.totalDebit}</td>
                                        <td>{row.totalCredit}</td>
                                        <td>{row.balance}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        ) : (
                            <p>No balance data available.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewLedger;
